// services/planService.js

import { meService } from 'src/api/authentication'
import { createStripeSessionService } from 'src/api/payment'
import { customerUpgradePortal } from 'src/api/limit'
import { loadStripe } from '@stripe/stripe-js'
import { track } from '@amplitude/analytics-browser'
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)

export const handleStripeCheckout = async (
  priceId,
  priceTrialDays,
  successReturnUrl,
) => {
  await meService()
  const resStripeSession = await createStripeSessionService(
    priceId,
    priceTrialDays,
    successReturnUrl,
  )

  const stripe = await stripePromise
  await stripe.redirectToCheckout({
    sessionId: resStripeSession.data.sessionId,
  })
}

export const handlePortalRedirection = async () => {
  const response = await customerUpgradePortal()
  window.open(response.data.sessionUrl)
}

export const trackPlanUpgrade = subscription => {
  track('upgrade_clicked', { subscription })
}

export const getAction = (groupId, subscription) => {
  switch (groupId) {
    case -1:
      return {
        Basic: {
          text: 'Basic Plan',
          disabled: true,
          tableText: 'Basic Plan',
          background: '#F4F6F8',
        },
        Pro: {
          text: 'Pro Plan',
          disabled: true,
          tableText: 'Pro Plan',
          background: '#F4F6F8',
        },
        Elite: {
          text: 'Elite Plan',
          disabled: true,
          tableText: 'Elite Plan',
          background: '#F4F6F8',
        },
      }[subscription]

    case 0:
      return {
        Basic: {
          text: 'Current Plan',
          disabled: true,
          tableText: 'Current Plan',
          background: '#F4F6F8',
        },
        Pro: {
          text: 'Upgrade to Pro Plan',
          disabled: false,
          tableText: 'Upgrade',
          background: '#E3F3FF',
        },
        Elite: {
          text: 'Upgrade to Elite Plan',
          disabled: false,
          tableText: 'Upgrade',
          background: '#E3F3FF',
        },
      }[subscription]

    case 1:
      return {
        Basic: {
          text: 'Switch to Free Plan',
          disabled: false,
          active: true,
          tableText: 'Free Plan',
          background: '#F4F6F8',
        },
        Pro: {
          text: 'Upgrade to Pro Plan',
          disabled: false,
          tableText: 'Upgrade',
          background: '#E3F3FF',
        },
        Elite: {
          text: 'Upgrade to Elite Plan',
          disabled: false,
          tableText: 'Upgrade',
          background: '#E3F3FF',
        },
      }[subscription]

    case 2:
      return {
        Basic: {
          text: 'Switch to Free Plan',
          disabled: false,
          active: true,
          tableText: 'Free Plan',
          background: '#F4F6F8',
        },
        Pro: {
          text: 'Current Plan',
          disabled: true,
          tableText: 'Current Plan',
          background: '#F4F6F8',
        },
        Elite: {
          text: 'Upgrade to Elite Plan',
          disabled: false,
          tableText: 'Upgrade',
          background: '#E3F3FF',
        },
      }[subscription]

    case 3:
      return {
        Basic: {
          text: 'Switch to Free Plan',
          disabled: false,
          active: true,
          tableText: 'Free Plan',
          background: '#F4F6F8',
        },
        Pro: {
          text: 'Switch to Pro Plan',
          disabled: false,
          active: true,
          tableText: 'Pro Plan',
          background: '#F4F6F8',
        },
        Elite: {
          text: 'Current',
          disabled: true,
          tableText: 'Current Plan',
          background: '#F4F6F8',
        },
      }[subscription]

    default:
      return null
  }
}
